import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { API_URL } from "../../Constants";
import axios from "axios";
import { Redirect } from "react-router-dom";

export default function StripeCheckoutForm({
    formSchema,
    isCpnApplied,
    price,
    couponDis,
    coupon,
    setPbStep,
}) {
    const [succeeded, setSucceeded] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState("");
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState("");
    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        // Create PaymentIntent as soon as the page loads
        fetch(`${API_URL}/payment/stripe_create_intent`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ orderID: formSchema.orderID }),
        })
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setClientSecret(data.clientSecret);
            });
    }, []);

    const cardStyle = {
        style: {
            base: {
                color: "#000000",
                fontFamily: "Poppins",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d",
                },
            },
            invalid: {
                color: "#ff0057",
                iconColor: "#ff0057",
            },
        },
    };

    const handleSubmit = async (ev) => {
        ev.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        setProcessing(true);
        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
            },
        });
        if (payload.error) {
            setError(`Payment failed ${payload.error.message}`);
            setProcessing(false);
        } else {
            setError(null);
            setProcessing(false);
            setSucceeded(true);
            if (isCpnApplied) {
                try {
                    const res = await axios({
                        method: "post",
                        url: `${API_URL}/coupon/applied`,
                        data: {
                            code: coupon,
                            orderID: formSchema.orderID,
                            o_amt: Number(couponDis) + Number(price.totalAmount),
                            d_amt: price.totalAmount,
                        },
                    });
                    if (res.data.status === "success") {
                        // setCurrentStep("successful");
                        setPbStep("successful");
                        setRedirect(true);
                    }
                } catch (err) {
                    console.log(err);
                }
            } else {
                // setCurrentStep("successful");
                setPbStep("successful");
                setRedirect(true);
            }
        }
    };

    const handleChange = async (event) => {
        // Listen for changes in the CardElement
        // and display any errors as the customer types their card details
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    return (
        <>
            {redirect ? (
                <Redirect
                    to={`/payment-successful?order-id=${formSchema.orderID}&stype=${formSchema.stype}&stl=me..69i57jA69FF59IjI0jJGD69iHF60l5.1721j0j7`}
                />
            ) : (
                ""
            )}
            <form id="payment-form" className="stripeForm" onSubmit={handleSubmit}>
                <CardElement
                    id="card-element"
                    options={cardStyle}
                    onChange={handleChange}
                />
                <button
                    disabled={processing || disabled || succeeded}
                    id="submit"
                    className="payBtn"
                >
                    <span id="button-text">
                        {processing ? (
                            <div className="spinners" id="spinners"></div>
                        ) : (
                            "Pay now"
                        )}
                    </span>
                </button>
                {/* Show any error that happens when processing the payment */}
                {error && (
                    <div className="card-error" role="alert">
                        {error}
                    </div>
                )}

                <img
                    src="https://assets.website-files.com/60d5e32a2e61d222f79c6145/60ddb6683b9cdcdc6905a306_stripe-badge-transparent.png"
                    loading="lazy"
                    alt=""
                    className="ud-secure-image"
                />
                {/* Show a success message upon completion */}
                {/* <p className={succeeded ? "result-message" : "result-message hidden"}>
                Payment succeeded, see the result in your
                <a
                    href={`https://dashboard.stripe.com/test/payments`}
                >
                    {" "}
                    Stripe dashboard.
                </a> Refresh the page to pay again.
            </p> */}
            </form>
        </>
    );
}
